import type { FieldConfig } from '@/mocks/questionnaire';
import { inputClass } from '@/pages/home/components/fields/styles';

interface TextAreaFieldProps {
  field: FieldConfig;
  value: string;
  onChange: (value: string) => void;
}

export default function TextAreaField({ field, value, onChange }: TextAreaFieldProps) {
  const limit = field.maxLength || 500;
  return (
    <div>
      <label
        htmlFor={field.name}
        className="block text-sm font-semibold text-foreground-900 mb-2"
      >
        {field.label}
        {field.hint ? (
          <span className="text-xs font-normal text-foreground-400 ml-1">{field.hint}</span>
        ) : null}
      </label>
      <textarea
        id={field.name}
        name={field.name}
        rows={field.rows || 4}
        maxLength={limit}
        value={value}
        onChange={(event) => onChange(event.target.value.slice(0, limit))}
        placeholder={field.placeholder}
        className={`${inputClass} resize-none leading-relaxed`}
      />
      <div className="flex justify-end mt-1">
        <span className="text-[11px] text-foreground-400">
          {value.length}/{limit}
        </span>
      </div>
    </div>
  );
}